import React from 'react';
import styled from 'styled-components';
import { FaHistory, FaRegUserCircle, FaWallet } from "react-icons/fa";
import Select from 'react-select';
import HistoryComponent from './HistoryComponent';
import TransactionComponent from './TransactionComponent';
import { ProfileComponent } from 'keycloakauthmodule';
import Wallet from './WalletComponent';
import { useLocation, useNavigate } from 'react-router-dom';
import Footer from './Footer';
import GradientLayout from './GradientLayout';

// Styled components
const Container = styled.div`
  display: flex;
  flex-direction: row;
  @media (max-width: 500px) {
    flex-direction: column;
  }
`;

const Sidebar = styled.div`
  width: 200px;
  background-color: #00171a;
  padding: 16px;
  overflow-y: auto;

  @media (max-width: 940px) {
    display: none;
  }
`;

const SidebarList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;

  .full-unstyled-link {
    display: flex;
    align-items: center;
    padding: 10px;
    text-decoration: none;
    color: white;
    cursor: pointer;

    &:hover {
      background-color: #6b8a99;
    }

    &.active {
      background-color: #6b8a99;
    }
  }

  svg {
    margin-right: 10px;
  }
`;

const ContentArea = styled.div`
  flex: 1;
  padding: 10px;
`;

const Dropdown = styled.div`
  display: none;
  margin-bottom: 10px;
  @media (max-width: 940px) {
    display: block;
  }
`;

// Select styles
const customStyles = {
  control: (provided: any, state: any) => ({
    ...provided,
    backgroundColor: '#00171a',
    color: 'white',
    border: state.isFocused ? '1px solid #6b8a99' : '1px solid #00171a',
    boxShadow: state.isFocused ? '0 0 0 1px #6b8a99' : 'none',
    '&:hover': { border: '1px solid #6b8a99' },
  }),
  menu: (provided: any) => ({ ...provided, backgroundColor: '#00171a' }),
  singleValue: (provided: any) => ({ ...provided, color: 'white' }),
  option: (provided: any, state: any) => ({
    ...provided,
    display: 'flex',
    alignItems: 'center',
    backgroundColor: state.isSelected ? '#6b8a99' : state.isFocused ? '#334e57' : '#00171a',
    color: 'white',
    '&:hover': { backgroundColor: '#6b8a99' },
  }),
  input: (provided: any) => ({ ...provided, color: 'white' }),
  indicatorSeparator: () => ({ display: 'none' }),
  dropdownIndicator: (provided: any) => ({ ...provided, color: 'white' }),
};

const options = [
  { value: 'profile', label: 'Profile', icon: <FaRegUserCircle /> },
  { value: 'account', label: 'Account', icon: <FaWallet /> },
  { value: 'transactions', label: 'Transactions', icon: <FaHistory /> },
  { value: 'history', label: 'Box History', icon: <FaHistory /> },
];

const IndicatorSeparator = () => null;

const ProfileDetailsLayoutComponent: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Determine which tab to show from the current path
  const pathSegment = location.pathname.split('/').filter(Boolean).pop() || 'profile';
  const selectedComponent = ['profile', 'account', 'transactions', 'history'].includes(pathSegment)
    ? pathSegment
    : 'profile';

  const handleSelectionChange = (selectedOption: any) => {
    navigate(`/${selectedOption.value}`);
  };

  const formatOptionLabel = (option: any) => (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      {option.icon}
      <span style={{ marginLeft: 10 }}>{option.label}</span>
    </div>
  );

  return (
    <GradientLayout background="linear-gradient(180deg, #00161a 0%, #00161a 12.5%, #00161a 100%)">

      <Container>
        <Sidebar>
          <SidebarList>
            <li>
              <a
                className={`full-unstyled-link ${selectedComponent === 'profile' ? 'active' : ''}`}
                onClick={() => navigate('/profile')}
              >
                <FaRegUserCircle />
                <span>Profile</span>
              </a>
            </li>
            <li>
              <a
                className={`full-unstyled-link ${selectedComponent === 'account' ? 'active' : ''}`}
                onClick={() => navigate('/account')}
              >
                <FaWallet />
                <span>Account</span>
              </a>
            </li>
            <li>
              <a
                className={`full-unstyled-link ${selectedComponent === 'transactions' ? 'active' : ''}`}
                onClick={() => navigate('/transactions')}
              >
                <FaHistory />
                <span>Transactions</span>
              </a>
            </li>
            <li>
              <a
                className={`full-unstyled-link ${selectedComponent === 'history' ? 'active' : ''}`}
                onClick={() => navigate('/history')}
              >
                <FaHistory />
                <span>Box History</span>
              </a>
            </li>
          </SidebarList>
        </Sidebar>

        <ContentArea>
          <Dropdown>
            <Select
              value={options.find((option) => option.value === selectedComponent)}
              onChange={handleSelectionChange}
              options={options}
              styles={customStyles}
              formatOptionLabel={formatOptionLabel}
              components={{ IndicatorSeparator }}
            />
          </Dropdown>

          {selectedComponent === 'profile' && <ProfileComponent />}
          {selectedComponent === 'account' && <Wallet />}
          {selectedComponent === 'transactions' && <TransactionComponent />}
          {selectedComponent === 'history' && <HistoryComponent />}
        </ContentArea>
      </Container>
    </GradientLayout>
  );
};

export default ProfileDetailsLayoutComponent;
